module.exports = __webpack_public_path__ + "img/construct.1217fd29.png";